import { render, staticRenderFns } from "./QuiltyInsightsListView.vue?vue&type=template&id=00512a9f&scoped=true&"
import script from "./QuiltyInsightsListView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyInsightsListView.vue?vue&type=script&lang=ts&"
import style0 from "./QuiltyInsightsListView.vue?vue&type=style&index=0&id=00512a9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00512a9f",
  null
  
)

export default component.exports